import { recover, scanLot } from "src/apis/pda1123Api";
import { useToast } from "src/hooks/useToast";
import usePDA1123_R01Store from "./usePDA1123_R01Store";

type ApiError = { response?: { data?: { message?: string } } };

export const usePDA1123_R01Content = () => {
  const store = usePDA1123_R01Store();
  const { success, error, warning } = useToast();

  const handleScanLot = async (scanValue?: string) => {
    const lotNo = (scanValue ?? store.lotInput).trim();
    if (!lotNo) {
      warning("LOT 번호를 스캔하세요.");
      return;
    }

    store.setLoading(true);
    try {
      const response = await scanLot(lotNo);
      const scan = response.data?.data;
      if (!scan) throw new Error("회수 대상이 아닙니다.");
      store.setScanResult(scan);
      success(`${scan.itemNm} (재고 ${scan.lotQty.toLocaleString()})`);
    } catch {
      store.setScanResult(null);
    } finally {
      store.setLotInput("");
      store.setLoading(false);
    }
  };

  const handleRecover = () => {
    if (!store.scanResult) {
      warning("LOT를 먼저 스캔하세요.");
      return;
    }
    const added = store.addRecover({
      productOrderNo: store.scanResult.productOrderNo,
      itemCd: store.scanResult.itemCd,
      lotNo: store.scanResult.lotNo,
      itemNm: store.scanResult.itemNm,
      lotQty: store.scanResult.lotQty,
      warehouseCd: store.scanResult.warehouseCd,
    });
    if (!added) {
      warning("이미 회수 목록에 있는 LOT입니다.");
      return;
    }
    success(`회수 추가 (${store.recoverList.length + 1}건)`);
    store.setScanResult(null);
    store.setLotInput("");
  };

  const handleRegister = async () => {
    if (store.recoverList.length === 0) {
      warning("회수할 LOT가 없습니다.");
      return;
    }

    store.setLoading(true);
    try {
      await recover({
        targetList: store.recoverList.map(({ productOrderNo, itemCd, lotNo }) => ({
          productOrderNo,
          itemCd,
          lotNo,
        })),
      });
      success(`자재 회수 완료 (LOT ${store.recoverList.length}건)`);
      store.clearRecover();
      store.setScanResult(null);
      store.setLotInput("");
    } catch (registerError: unknown) {
      const message =
        (registerError as ApiError).response?.data?.message || "자재 회수에 실패했습니다.";
      error(message);
    } finally {
      store.setLoading(false);
    }
  };

  return { handleScanLot, handleRecover, handleRegister };
};
